import React from 'react';
import NextButton from './NextButton';
import PrevButton from './PrevButton';
import { Container, Row, Col } from 'reactstrap';
import useSteps from '../StepContext/useSteps';
import ConfirmButton from './ConfirmButton';
import { useTranslator, useAppContext } from '@front-activerse/common-components';

const Footer: React.FC = () => {
  const { isLastStep, currentMainStep } = useSteps();
  const { t } = useTranslator();

  const {
    images: { infoIcon },
  } = useAppContext();

  const renderConfirmAndNextBtn = () => {
    return isLastStep ? <ConfirmButton /> : <NextButton />;
  };

  return (
    <div className="sticky-footer">
      <Container>
        <Row>
          <Col md={{ size: 6, offset: 3 }}>
            {(currentMainStep === 'biometric' || currentMainStep === 'goalSettings') &&
              isLastStep && (
                <div className="changeMealsNotification d-flex align-items-center">
                  <img src={infoIcon} className="me-s" alt="" />
                  {currentMainStep === 'biometric' ? (
                    <p>{t('biometric.summary.changeMealsNotification')}</p>
                  ) : (
                    <p>{t('goalSettings.summary.changeMealsNotification')}</p>
                  )}
                </div>
              )}

            <div className="d-none d-md-block">
              <div className="position-relative">
                <div className="d-flex">
                  <PrevButton />
                  {renderConfirmAndNextBtn()}
                </div>
              </div>
            </div>
            <div className="d-md-none">{renderConfirmAndNextBtn()}</div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Footer;
